import React, { useState } from 'react';

import Icon from '@mdi/react';
import { mdiChevronRight as ExpandIcon } from '@mdi/js';

import './accordion.scss';

type AccordionProps = {
  isExpanded: boolean;
  id: string;
  title: string;
  children: string;
};

const Accordion = ({ id, title, children }: AccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div key={id} className='accordion-item'>
      <button
        className={`accordion-button ${isExpanded ? 'expanded' : ''}`}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
        aria-controls={`accordion-content-${id}`}
      >
        <span className='accordion-title'>{title}</span>
        <Icon path={ExpandIcon} size={1} className={`accordion-icon ${isExpanded ? 'rotated' : ''}`} />
      </button>
      {isExpanded && (
        <div id={`accordion-content-${id}`} className='accordion-content-wrapper'>
          <div className='accordion-content'>{children}</div>
        </div>
      )}
    </div>
  );
};

export default Accordion;
